import { MAX_UPLOAD_BYTES } from 'features/bug-report/constants'
import type { Attachment } from 'features/bug-report/types'
import { readFileAsDataUrl } from 'features/bug-report/utils/encoding'

export type UploadProcessResult = {
  accepted: Attachment[]
  errors: string[]
}

export async function processUploadedFiles(
  files: File[],
): Promise<UploadProcessResult> {
  const accepted: Attachment[] = []
  const errors: string[] = []
  for (const file of files) {
    if (file.size > MAX_UPLOAD_BYTES) {
      errors.push(`${file.name} is over 20 MB.`)
      continue
    }
    try {
      const dataUrl = await readFileAsDataUrl(file)
      accepted.push({
        id: `upload-${Date.now()}-${file.name}`,
        dataUrl,
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        label: file.name,
        removable: true,
      })
    } catch {
      errors.push(`Could not read ${file.name}.`)
    }
  }
  return { accepted, errors }
}
